import { render } from "./About.vue?vue&type=template&id=dcde480e"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=dcde480e&lang=css"
script.render = render

export default script